// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"list_placeholder__2my1B","icon":"list_icon__qoc8w"};